import { createSlice } from '@reduxjs/toolkit';
import { loadSides, loadPolygons } from '../actions/Beacon4BlendedActions';

const initialState = {
	platform:         'Foresight',
	type:             'Others',
	side:             '',
	selectedPolygons: [],
	sides:            [],
	polygons:         [],
	loadingSides:     false,
	loadingPolygons:  false,
	error:            null,
	viewYear:         null,   // frontend-only year filter, null = all years
};

const filtersSlice = createSlice({
	name: 'filters',
	initialState,
	reducers: {
		setPlatform:         (state, action) => { state.platform = action.payload; },
		setType:             (state, action) => { state.type     = action.payload; },
		setSide:             (state, action) => { state.side = action.payload; state.selectedPolygons = []; state.polygons = []; },
		setSelectedPolygons: (state, action) => { state.selectedPolygons = action.payload; },
		selectAllPolygons:   (state)         => { state.selectedPolygons = []; },
		resetFilters:        (state)         => { state.side = ''; state.selectedPolygons = []; state.polygons = []; },
		setViewYear:         (state, action) => { state.viewYear = action.payload; },
		resetViewYear:       (state)         => { state.viewYear = null; },
	},
	extraReducers: (builder) => {
		builder
			.addCase(loadSides.pending,      (state) => { state.loadingSides = true; state.error = null; })
			.addCase(loadSides.fulfilled,    (state, action) => {
				state.loadingSides = false;
				state.sides        = action.payload.sides ?? [];
				if (!state.side && state.sides.length) state.side = state.sides[0];
			})
			.addCase(loadSides.rejected,     (state, action) => { state.loadingSides = false; state.error = action.payload; })
			.addCase(loadPolygons.pending,   (state) => { state.loadingPolygons = true; state.error = null; })
			.addCase(loadPolygons.fulfilled, (state, action) => {
				state.loadingPolygons = false;
				state.polygons        = action.payload.polygons ?? [];
				if (!state.selectedPolygons.length && state.polygons.length)
					state.selectedPolygons = [state.polygons[0]];
			})
			.addCase(loadPolygons.rejected,  (state, action) => { state.loadingPolygons = false; state.error = action.payload; });
	},
});

export const {
	setPlatform, setType, setSide,
	setSelectedPolygons, selectAllPolygons,
	resetFilters, setViewYear, resetViewYear,
} = filtersSlice.actions;
export default filtersSlice.reducer;